import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    padding: 10,
    backgroundColor: '#E7E7E7',
    border: '1px solid #D4D5D9',
    borderRadius: 4,
    marginBottom: 6
  }
})

export default useStyles
